import { Environment } from '../environment';
import { CookieHelper } from '../utils';
import { DeviceType } from './enums';
import { Size } from './model';

export class ClientInfo {

    id: string;
    userAgent: string;
    deviceType: DeviceType;
    screenSize: Size;
    windowSize: Size;
    osName: string;
    osVersion: string;
    browserName: string;
    browserVersion: string;
    cookiesEnabled: boolean;

    constructor(id: string) {
        const w: Window = window,
            d: Document = document,
            e: HTMLElement = d.documentElement,
            g: HTMLBodyElement = d.getElementsByTagName('body')[0],
            windowWidth: number = w.innerWidth || e.clientWidth || g.clientWidth,
            windowHeight: number = w.innerHeight || e.clientHeight || g.clientHeight;

        this.id = id;
        // this.userAgent = navigator.userAgent;
        this.browserName = Environment.BrowserName;
        this.browserVersion = Environment.Browser.version.version;
        this.osName = Environment.OsName;
        this.osVersion = Environment.OS.version.version;
        this.cookiesEnabled = CookieHelper.cookiesEnabled();

        this.screenSize = {
            width: screen.width,
            height: screen.height,
        };

        this.windowSize = {
            width: windowWidth,
            height: windowHeight,
        };

        this.deviceType = DeviceType.Desktop;
        if (this.osName == 'mac') {
            this.deviceType = DeviceType.Desktop;
        } else if (this.osName == 'iPhone') {
            this.deviceType = DeviceType.Phone;
        } else if (this.osName == 'Tablet') {
            this.deviceType = DeviceType.Tablet;
        } else if (this.screenSize.width < 1300) {
            this.deviceType = DeviceType.Tablet;
            if (this.screenSize.width < 600) {
                this.deviceType = DeviceType.Phone;
            }
        } else {
            this.deviceType = DeviceType.Desktop;
        }
    }
}
